import React from 'react';

const Menu = (props) => (
	<svg
		id="ikony"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<rect x={1} y={1} width={20} height={3}/>
			<rect x={1} y={18} width={20} height={3}/>
			<rect x={1} y={9.5} width={20} height={3}/>
		</g>
	</svg>
)

export default Menu;
